import { useState, useCallback } from "react";
import { CanCreateConversation, canCreateConversation } from "../api/config";
import { CurrentChatStatus } from "@/app/store/types";
import { useMessageStore } from "../store";

export const useChatInit = () => {
  const setCurrentChatStatus = useMessageStore(
    (state) => state.setCurrentChatStatus,
  );
  const [canService, setCanService] = useState<boolean | null>(null);
  const [checkCanServiceInfo, setCheckCanServiceInfo] =
    useState<CanCreateConversation | null>(null);

  /**
   * 实时检查客服是否可用（每次调用都会请求接口获取最新状态）
   * @returns 是否可以创建会话
   */
  const checkCanService = useCallback(async () => {
    try {
      const agentServiceInfo = await canCreateConversation();
      const result =
        agentServiceInfo.online ||
        (!agentServiceInfo.online && agentServiceInfo.hasActiveConversation);
      setCanService(result);
      if (!result) {
        if (typeof window !== "undefined") {
          window.globalData = window.globalData || {};
          window.globalData.workTime = agentServiceInfo.content;
        }
        setCurrentChatStatus(CurrentChatStatus.AgentNotService);
      }
      setCheckCanServiceInfo(agentServiceInfo);
      return result;
    } catch {
      return false;
    }
  }, []);

  return { canService, checkCanService, checkCanServiceInfo };
};
